module.exports = __webpack_public_path__ + "260840f05086f67e0fa6786546c8f6fa.png";